import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { FlexCol, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { H2Title, Title } from '../General/Title';
import { TextP } from '../../Defaults/Text';
import { Tag, TagType } from '../Product/Tag';
import { SaleBubble } from './SaleBubble';
import { IsInCartAlready } from './LeftUpper';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { SaleBubbleNew } from './SaleBubbleNew';

interface Props {
  title: string;
  image: string;
  issaleout: number;
  isnew: number;
  issale: number;
  specialDiscount: string;
  isInCart: boolean;
  theme: any;
  showFullImage?: boolean;
}

function ProductTitleImage({
  title,
  image,
  issaleout,
  isnew,
  issale,
  specialDiscount,
  isInCart,
  theme,
  showFullImage,
}: Props) {
  return (
    <Wrapper>
      <H2Title marginTop={0} marginBottom={24}>
        {title}
      </H2Title>
      {isInCart && (
        <IsInCartAlready>
          {__('Produkt sa nachádza v košíku')}
          <SvgIcon
            icon={IconType.cart}
            fill={theme.colors.primary}
            marginLeft={8}
            alt={__('Produkt sa nachádza v košíku')}
            title={__('Produkt sa nachádza v košíku')}
          />
        </IsInCartAlready>
      )}
      <ImageWrapper
        imgSrc={
          showFullImage
            ? (image || '').replace(
                '&width=160&height=160',
                '&width=441&height=328',
              )
            : image
        }
        showFullImage={showFullImage}
      >
        <TagWrapper>
          {isnew ? (
            <TagRelativeWrapper>
              <Tag text={'Novinka'} type={TagType.NEW} />
            </TagRelativeWrapper>
          ) : null}
          {issaleout ? (
            <TagRelativeWrapper>
              <Tag text={'Výpredaj'} type={TagType.SALEOUT} />
            </TagRelativeWrapper>
          ) : null}
          {issale ? (
            <TagRelativeWrapper>
              <Tag text={'Akcia'} type={TagType.ACTION} />
            </TagRelativeWrapper>
          ) : null}
        </TagWrapper>
        {specialDiscount ? (
          <SaleBubbleNew isMobile={true} text={specialDiscount} />
        ) : null}
      </ImageWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  color: #aaaaaa;
  position: relative;
  margin-right: ${rem(32)};

  &:focus-within {
    color: ${props => props.theme.colors.btnPrimary};
  }

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
    margin-bottom: ${rem(8)};
  `}

  ${({ theme }) => theme.mediab.s450`
    max-width: initial;
  `}
`;

const ImageWrapper = styled.div<{ imgSrc: string; showFullImage?: boolean }>`
  /* max-width: ${rem(328)}; */
  min-width: ${rem(288)};
  height: ${rem(328)};
  width: 100%;
  background-image: url('${({ imgSrc }) => imgSrc}');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: ${({ showFullImage }) => (showFullImage ? '90%' : 'auto')};
  position: relative;
  margin-right: ${rem(32)};
  border: ${({ theme }) => theme.borders.primary};
  border-radius: ${rem(4)};

  ${({ theme }) => theme.mediab.s450`
    min-width: initial;
    max-width: initial;
  `}
`;

const TagRelativeWrapper = styled.div`
  margin-right: ${rem(8)};
`;

const TagWrapper = styled(FlexRow)`
  position: absolute;
  top: ${rem(16)};
  left: ${rem(16)};
`;

const WithTheme: any = withTheme(ProductTitleImage);
export { WithTheme as ProductTitleImage };
